export default {
  contacts: {
    rationale: {
      IMPLIED_CONSENT: "Implied consent",
      CONTACT_OPTED_IN: "Opted in",
      CONTACT_OPTED_OUT: "Opted out",
      LEGITIMATE_INTEREST: "Legitimate interest",
      CONTACT_DID_NOT_OPT_IN: "Did not opt in",
      CONTACT_DID_NOT_OPT_OUT: "Did not opt out",
      CONTACT_DID_DOUBLE_OPT_IN: "Double opted in",
      CONTACT_HAS_NOT_COMPLETED_DOUBLE_OPT_IN: "Incomplete double opt in",
      CONTACT_ADDED_TO_EXCLUSION_LIST_OUTSIDE_OF_DATASHIPS: "On exclusion list",
      INSUFFICIENT_LANGUAGE_IN_PRIVACY_POLICY_SHOWN_TO_USER:
        "Missing privacy policy",
      MISMATCH_BETWEEN_CONTACT_IP_COUNTRY_AND_SHOPIFY_COUNTRY:
        "Country unclear",
      INSUFFICIENT_LANGUAGE_SHOWN_TO_USER:
        "Insufficient compliance information",
      CONTACT_UNSUBSCRIBED: "Unsubscribed",
      CONTACT_WAS_NOT_SENT_DOUBLE_OPTIN_CONFIRMATION_SMS:
        "No double opt in SMS sent",
      INSUFFICIENT_CONSENT_COLLECTED: "Insufficient level of consent",
      CONTACT_DID_NOT_MEET_CONSENT_REQUIREMENT_DUE_TO_INCOMPLETE_PURCHASE:
        "Abandoned purchase",
    },
  },
  auditLogs: {
    header: {
      feature: "Audit Logs",
      heading: "Marketing Audit Log for your Contacts",
      description:
        "Check out the table below to see a list of your contacts and their marketable statuses. Click into any contact to see the details of their status and a full log of how it was arrived at.",
    },
    tabs: {
      marketable: "Marketable",
      nonMarketable: "Non Marketable",
    },
    table: {
      columns: {
        EMAIL: "Email",
        SMS: "Phone Number",
        name: "Name",
        status: {
          title: "Status",
          marketable: "Marketable",
          nonMarketable: "Non Marketable",
        },
        rationale: "Rationale",
        lastModifiedAt: "Last Modified At",
        details: "Details",
      },
      detailsButton: "Details",
      row: {
        unknown: "Name Unknown",
      },
    },
  },
  complianceReports: {
    header: {
      feature: "Compliance Reports",
      heading: "Compliance Reports",
      description:
        "Check out your list of essential compliance reports below. These reports ensure you have the appropriate documentation in place in order to make the most of global data privacy laws compliantly.",
    },
    table: {
      reportType: "Report Type",
      status: {
        title: "Status",
        DRAFT: "Draft",
        COMPLETE: "Complete",
      },
      date: "Date",
      action: "Action",
      view: "View",
    },
  },
  marketableAudiences: {
    header: {
      feature: "Marketable Audiences",
      heading: "Marketable Status of your Contacts",
      description: {
        EMAIL:
          "Check out the marketable status of your contacts below. These statuses are also synced with your Marketing Automation tool so that they're easily usable. You can click the button below to open Klaviyo to email your Marketable Audience.",
        SMS: "Check out the marketable status of your contacts below. These statuses are also synced with your Marketing Automation tool so that they're easily usable. You can click the button below to open Klaviyo to message your Marketable Audience.",
      },
    },
    cta: "Open Klaviyo",
    tabs: {
      marketable: "Marketable",
      nonMarketable: "Non Marketable",
    },
    table: {
      columns: {
        identifier: {
          EMAIL: "Email",
          SMS: "Phone Number",
        },
        name: "Name",
        status: {
          header: "Status",
          true: "Marketable",
          false: "Non-marketable",
        },
        rationale: "Rationale",
        lastModifiedAt: "Last Modified",
      },
      row: {
        unknown: "Name Unknown",
      },
    },
  },
  complianceReport: {
    header: {
      feature: "Compliance Reports",
      heading: "Legitimate Interest Assessment",
    },
    content: {
      info: {
        heading:
          "What is a Legitimate Interest Assessment and why must I complete one?",
        paragraph1:
          'In GDPR, there are 6 legal grounds for processing personal data. The 3 most commonly used in E-commerce are performance of a contract, consent, and having a legitimate interest. Legitimate interest is a broad category that can cover business, personal, or societal benefits. GDPR says it can be used, but not if it harms the rights or freedom of the people whose data is involved. So, companies need to do a "legitimate interest assessment" (LIA) to show they\'ve thought about how it might affect people.',
        paragraph2:
          'For Dataships, some of your contacts might be marked as "Marketable" based on your Legitimate Interest, therefore you must do this Legitimate Interest Assessment (LIA). The LIA has three parts:',
        list1:
          "<0>Part 1 The Purpose Test:</0> Consider if you really have a good reason for processing this data.",
        list2:
          "<0>Part 2 The Necessity Test:</0> See if you really need this data, or if there's another way to do it without using as much or different data.",
        list3:
          "<0>Part 3 The Balancing Test:</0> Look at how this might affect your customers' rights and freedom, and whether that's more important than your legitimate interest.",
        paragraph3:
          "After doing all three parts, you can decide if you can use the legitimate interest reason to process the data. It's a way to make sure you're being fair and thinking about people's rights.",
        paragraph4: "So what now?",
        paragraph5:
          "<0>Read through</0> the 3-part test below and if you're happy <2>tick the box</2> to say you've reviewed the assessment and <4>Click Done.</4>",
      },
      part1: {
        heading: "Part 1: Purpose test",
        italics:
          "Here you need to assess whether there is a legitimate interest behind the processing.",
        question1: "Why do you want to process the data?",
        answer1:
          "We aim to process this data to inform both new and existing customers about special offers, new similar products/services, and promotional materials. By doing so, we strive to maintain an engaged and well-informed customer base. This approach not only encourages repeat purchases but also empowers customers to make informed choices, ensuring they derive the maximum value from their transactions with us.",
        question2: "What benefit do you expect to get from the processing?",
        answer2:
          "The primary benefit we anticipate is building and nurturing strong, lasting relationships with our customers. By providing them with relevant and valuable information, we aim to increase customer engagement and satisfaction and boost our sales.",
        question3: "Do any third parties benefit from the processing?",
        answer3:
          "No, the processing we undertake is solely for the purpose of enhancing the customer experience and engagement and does not benefit any third parties.",
        question4: "Are there any wider public benefits to the processing?",
        answer4:
          "While the primary aim is to serve our customers better, there can be indirect wider benefits. By maintaining a trusted and customer-centric approach, we contribute to creating a culture of responsible and transparent data handling in the broader business community.",
        question5: "How important are the benefits that you have identified?",
        answer5:
          "We consider these benefits as crucial for our ongoing business success. Building strong customer relationships and ensuring a quality customer experience are central to our operations. Furthermore, offering customers the choice to opt out or object to their data being used for direct marketing purposes is not only a legal requirement but also a fundamental part of providing a respectful and compliant service.",
        question6:
          "What would the impact be if you couldn’t go ahead with the processing?",
        answer6:
          "In the absence of this data processing, we would lose the ability to maintain direct communication with both new and existing customers, which could harm the development of trusted relationships. As a result, there might be a decline in sales.",
        question7:
          "Are you complying with any specific data protection rules that apply to your processing (e.g., profiling requirements, or e-privacy legislation)?",
        answer71:
          "We are in full compliance with both GDPR and ePrivacy regulations. During the checkout process, we provide clear and transparent information to customers about our data processing intentions for direct marketing. We also present our privacy policy and give customers the option to object or opt out. Additionally, we provide the option for customers to object or opt out in all communication we send, if they haven't done so already.",
        answer72:
          "To align with best practices and guidance from European data protection authorities, we present customers with an unticked checkbox which they can tick to opt-out, rather than a pre-ticked opt-in box. We also transparently inform customers about their right to object and how they can exercise this right.",
        question8: "Are you complying with other relevant laws?",
        answer8:
          "Yes, we are diligent in adhering to all applicable laws beyond data protection, ensuring that our practices are in line with other legal requirements relevant to our operations.",
        question9:
          "Are you complying with industry guidelines or codes of practice?",
        answer9:
          "We are actively following industry best practices and guidance, including those recommended by EU data protection authorities, to maintain high standards in data protection. This includes providing clear and easily accessible opt-out options and comprehensive information for our customers.",
        question10: "Are there any other ethical issues with the processing?",
        answer10:
          "We prioritize ethical considerations in our processing. We are committed to maintaining transparency, respecting customers' choices, and ensuring that they have full control over their data. Our practices align with ethical standards to provide customers with a trustworthy and responsible experience.",
      },
      part2: {
        heading: "Part 2: Necessity test",
        italics:
          "You need to assess whether the processing is necessary for the purpose you have identified.",
        question1:
          "Will this processing actually help you achieve your purpose?",
        answer1:
          "Yes, processing the contact information of customers is essential to build and maintain an engaged and well-informed customer base. This processing directly contributes to the purpose of keeping customers informed about special offers and new products or services.",
        question2: "Is the processing proportionate to that purpose?",
        answer2:
          "Absolutely, the processing is proportionate to the purpose. We only process the necessary and minimal personal data required to send promotional material, including the customer's name, previous orders, and either their email address, phone number, or address.",
        question3: "Can you achieve the same purpose without the processing?",
        answer3:
          "No, achieving the purpose of sending promotional material would not be possible without processing the contact information of customers. This processing is integral to keeping customers informed and engaged.",
        question4:
          "Can you achieve the same purpose by processing less data, or by processing the data in another more obvious or less intrusive way?",
        answer4:
          "We ensure minimal intrusion by processing only the essential data needed for the purpose. We limit the data processing to the customer's name, previous orders, and either their email address, phone number, or address. This approach respects privacy while achieving the goal of sending relevant promotional material.",
      },
      part3: {
        heading: "Part 3: Balancing test",
        italics:
          "You need to consider the impact on individuals’ interests and rights and freedoms and assess whether this overrides your legitimate interests.",
        sub_heading1: "Nature of the personal data",
        question1: "Is it special category data or criminal offence data?",
        answer1:
          "No, the personal data in scope does not include special category data or criminal offence data. It primarily consists of previous order details and basic contact information, including names, email addresses, phone numbers, and/or addresses. We collect this information directly from the customer. We process details of previous orders to ensure our marketing pertains to similar products/services in line with ePrivacy requirements.",
        question2:
          "Is it data which people are likely to consider particularly ‘private’?",
        answer2:
          "No, the processed data is not typically considered 'private.' It mainly involves basic contact information that individuals often share routinely and previous order details. We collect this information directly from the customer.",
        question3:
          "Are you processing children’s data or data relating to other vulnerable people?",
        answer3:
          "We do not intentionally process children's data or data related to other vulnerable individuals.",
        question4:
          "Is the data about people in their personal or professional capacity?",
        answer4:
          "The data we process pertains to individuals in their personal capacity.",
        sub_heading2: "Reasonable expectations",
        question5:
          "Do you have an existing relationship with the individual? What's the nature of the relationship and how have you used data in the past?",
        answer5:
          "Yes, we have an existing relationship with these individuals as they have recently made a purchase or used our product/service. We have collected their personal data directly from them during the checkout process. At that point, we provide clear and transparent information regarding our intent to process their data for direct marketing purposes. We also present our privacy policy and offer the option for individuals to object or opt out for each applicable direct marketing channel. The same choice is presented in every communication we send, ensuring they have the opportunity to opt out if they haven't already. We adhere to best practice guidelines from EU supervisory authorities by utilizing unticked opt-out checkboxes, as opposed to pre-ticked opt-in boxes. Additionally, we make it evident that they have the right to object and clarify how to exercise this right. The processing of personal data for direct marketing purposes is widely understood, and we do not plan to introduce any new or innovative uses for the data.",
        question6:
          "Are there any other factors in the particular circumstances that mean they would or would not expect the processing?",
        answer6:
          "While direct marketing through social media is a relatively newer form of direct marketing compared to email or direct mail, we ensure transparency. When this channel is in scope, we provide customers with the option to opt out of receiving direct marketing via social media. Consequently, if they do not opt out, they can reasonably expect that their personal data will be used for direct marketing purposes through social media. We prioritize clear and informed choices for our customers across all channels.",
        sub_heading3: "Likely impact",
        question7: "What are the possible impacts of the processing on people?",
        answer7:
          "The potential impacts of this processing are twofold. Positively, customers will benefit from staying informed about new products and services that align with their interests and receive exclusive offers. Conversely, a negative impact could arise if a customer finds the marketing communications uninteresting. However, we provide a straightforward and easily accessible method for customers to unsubscribe or object to the processing of their personal data for direct marketing purposes, ensuring they retain control over their data usage.",
        question8:
          "Will individuals lose any control over the use of their personal data?",
        answer8:
          "No, individuals will not lose control over the use of their personal data. We are committed to upholding their rights to object, and we facilitate this choice in a clear and user-friendly manner.",
        question9:
          "What is the likelihood and severity of any potential impact?",
        answer9:
          "While it is possible that some individuals might choose to object to their personal data being processed for direct marketing, we actively work to establish a positive and trustful relationship with our customers. This mitigates the likelihood and severity of any potential negative impact by ensuring our direct marketing is not intrusive or overwhelming.",
        question10:
          "Are some people likely to object to the processing or find it intrusive?",
        answer10:
          "While it's possible that some individuals may choose to object to the processing, our primary objective is to create a positive and trustful relationship with our customers. We aim to provide marketing communications that are relevant and engaging, not intrusive.",
        question11:
          "Would you be happy to explain the processing to individuals?",
        answer11:
          "Absolutely, we have no reservations about explaining this processing to individuals. We've made every effort to convey this process as clearly as possible within our checkout and privacy policy. Our commitment is to maintain transparency and provide customers with the information they need to make informed choices about their data.",
        question12: "Can you adopt any safeguards to minimize the impact?",
        answer12:
          "We have implemented several safeguards to minimize the impact of our direct marketing. These include offering an easy opt-out option, presenting information in a transparent and user-friendly manner at the time of sale and in each communication, and ensuring that marketing communications are relevant and sent at a non-intrusive frequency. These safeguards are in place to prioritize a positive customer experience.",
        question13: "Can you offer individuals an opt-out?",
        answer13: "Yes, we do this during the course of the sale.",
      },
      decision: {
        heading: "Making the decision",
        italics:
          "This is where you use your answers to Parts 1, 2 and 3 to decide whether or not you can apply the legitimate interests basis.",
        question1: "Can you rely on legitimate interests for this processing?",
        answer1: "Yes.",
        question2: "Do you have any comments to justify your answer?",
        answer2:
          "Relying on legitimate interests for the processing of personal data for direct marketing is justified by a well-rounded assessment. In the Purpose Test, we have established the importance of maintaining customer relationships, enhancing customer engagement, and offering a transparent and compliant service, all of which are fundamental to our business success. The Necessity Test underscores the essential role of this processing in achieving our purpose while ensuring minimal intrusion. The Balancing Test highlights that the processed data is neither sensitive nor private, and we actively uphold individuals' rights, allowing them to object and opt out but at the time of sale and in each communication. Moreover, compliance with data protection rules, laws, and ethical considerations is integral to our processing approach. These collective factors justify our reliance on legitimate interests, prioritizing a positive customer experience while maintaining respect for individual choices and privacy.",
        completed_by: "<0>LIA completed by:</0> {{email}}",
        completed_date: "<0>Date:</0> {{date}}",
      },
    },
    bottomBar: {
      label:
        "By clicking I agree I have reviewed the report and am satisfied with its contents",
      button: "I agree",
    },
  },
  contactDetailsView: {
    header: {
      feature: "Audit Logs",
      heading: "Records of consent",
      description:
        "Here you can find the log of this contact's consent records and the full detail for each record.",
    },
    marketable: "Marketable",
    nonMarketable: "Non Marketable",
    table: {
      title: "Consent Record Detail",
      formType: {
        CHECKOUT_INFORMATION: "Checkout (Information)",
        THANK_YOU: "Checkout (Thank You)",
        SNIPPET: "Checkout (Thank You)",
        DOUBLE_OPT_IN_CONFIRMATION_EMAIL: "Double Opt-in confirmation e-mail",
        DOUBLE_OPT_IN_CONFIRMATION_SMS: "Double Opt-in confirmation SMS",
        DATASHIPS_DOUBLE_OPT_IN_CONFIRMATION_SMS:
          "Dataships Double Opt-in Checkout Form",
      },
      nameUnknown: "Name Unknown",
      action: {
        unsubscribe_sms: "Unsubscribed from SMS",
        did_double_opt_in: "Double opted in",
        opt_out: "Opted out",
        opt_in: "Opted in",
        did_not_opt_out: "Did not opt out",
        did_not_opt_in: "Did not opt in",
        no_opt_in: "Did not opt in",
        no_opt_out: "Did not opt out",
        none: "None",
        did_not_none: "None",
        action_suppressed_list: "Contact excluded in Klaviyo",
        action_double_optin_confirmed: "Confirmed double opt in",
        action_sms_double_optin_verification:
          "Dataships confirmed double opt in",
        action_removed_from_suppressed_list: "Removed from suppressed list",
        entered_correct_verification: "Entered correct verification code",
      },
      legalBasis: {
        CONSENT: "Consent",
        LEGITIMATE_INTEREST: "Legitimate Interest",
        IMPLIED_CONSENT: "Implied Consent",
      },
    },
    historyTable: {
      contactHistoryId: "Contact History ID",
      status: {
        title: "Status",
        marketable: "Marketable",
        nonMarketable: "Non Marketable",
      },
      rationale: "Rationale",
      date: "Date",
      details: "Details",
    },
  },
  signup: {
    form: {
      email: {
        label: "Email Address",
        placeholder: "Insert your company email address",
        errors: {
          empty: "You must supply an email address.",
          workEmail: "You must supply a valid work email address.",
        },
      },
      password: {
        label: "Password",
        placeholder: "Choose your password",
        helper: "Use at least 10 characters",
        errors: {
          empty: "You must supply a password.",
          requirements: "Password is invalid (minimum is 10 characters)",
        },
      },
      firstName: {
        label: "First Name",
        empty: "You must supply your first name",
        placeholder: "Insert your first name",
      },
      lastName: {
        label: "Last Name",
        empty: "You must supply your last name",
        placeholder: "Insert your last name",
      },
      checkboxes: {
        marketingConsent:
          "Keep me up to date with news and new product information",
      },
      buttons: {
        cta: "Continue with email",
        agree:
          "By creating an account you are agreeing to Dataships <1>Terms of Use</1> and <3>Privacy Practices</3>.",
        secondary: "Already have an account?",
      },
      emailError: "Please check your email for a message from Dataships.",
    },
  },
} as const;
